declare const ENV_USE_CACHE: boolean;

/**
 * Global veriable check, which indicates if `--use-cache` was used
 * as a flag to webpack command. If so, we should load cached
 * Storyblok content instead making request to API.
 */
export const isCacheMode = () =>
    typeof ENV_USE_CACHE !== 'undefined' && ENV_USE_CACHE;
